export const companyType = [
    { id: 0, title: '未上市' },
    { id: 1, title: '沪深' },
    { id: 2, title: '港股' },
    { id: 3, title: '美股' },
    { id: 4, title: '台湾' },
]
export const isDelete = [
    { id: 0, title: '正常' },
    { id: 1, title: '删除' },
    { id: 2, title: '退市' },
    { id: 3, title: '停牌' },
    { id: 4, title: '清盘' },
    { id: 5, title: '取消上市' },
    { id: 6, title: '暂停上市' },
    { id: 7, title: '未发年报' },
    { id: 8, title: '不参与调研' },
]


export const targetType = [
  {id : 0, title: '定量'},
  {id : 1, title: '定性'},
];

export const targetSource = [
  {id : 0 , title:'年报' },
  {id : 1 , title:'社报' },
  {id : 2 , title:'舆情' }
];

export const classification = [
  {id : 0 , title:'通用指标' },
  {id : 1 , title:'行业指标' },
]

export const audit = [
  { id: '1', name: '待审核' },
  { id: '2', name: '不通过' },
  { id: '3', name: '通过' },
]

export const esg_ordering = [
  { id: 'stockCode', name: '按股票代码排序' },
  { id: 'score', name: '按评分排序' },
  { id: 'weightedScore', name: "按总得分排序" },
]
export const esg_census = [
  { id: '0', name: "按期统计" },
  { id: '1', name: "按月统计" },
]

export const listedTargetType = [
  {id : 0, title: '舆情'},
  {id : 1, title: '青悦'},
  {id : 2, title: '预警通'},
];
